"use client";

import type { FilterableProduct, RawAttributeAggregations } from "@jti/commerce/features";
import { ProductAttributeFiltersDrawer as ProductAttributeFiltersDrawerUI } from "@jti/commerce/features";

import { useFilter } from "@/context/FilterContext";

import type { AttributeFiltersInputs } from "./ProductAttributeFiltersDrawer.inputs.builder";

type AttributeFiltersProps = AttributeFiltersInputs & {
  attributeAggregations?: RawAttributeAggregations;
  products?: FilterableProduct[];
};

export const ProductAttributeFiltersDrawer = ({
  filterSections,
  attributeAggregations = [],
  products = [],
}: AttributeFiltersProps) => {
  const filterContext = useFilter({ optional: true });

  if (!filterContext) return null;

  const { filterState, setSelectedAttributes, clearAttributes } = filterContext;

  return (
    <ProductAttributeFiltersDrawerUI
      filterSections={filterSections}
      attributeAggregations={attributeAggregations}
      products={products}
      selectedAttributes={filterState.selectedAttributes}
      onApply={setSelectedAttributes}
      onReset={clearAttributes}
    />
  );
};
